/**
 * Dynamic reward constants — §5
 */
import type { StarPackage } from './static-reward.js';

/** 平衡奖 = 对碰额 × 5% */
export const BALANCE_AWARD_PCT = '0.05';

/** 平级辅导 A2/A3/A4 */
export const PEER_LEVEL_BONUS_EP = '5';
export const PEER_LEVEL_CODES = ['A2', 'A3', 'A4'] as const;

/**
 * 分享奖平级上限 — 同一等级最多 2 人收款：
 * 第 1 个拿级别奖励（级差），第 2 个拿固定平级 EP，第 3 个不再发。
 */
export const SHARE_BONUS_SAME_LEVEL_MAX = 2;

/** 分享奖平级固定金额（同级第 2 人；池外发放）。 */
export const SHARE_BONUS_PEER_EP = '5';

/** Cumulative share-bonus EP cap by upline level (E2 / 1000$ package). */
export const SHARE_BONUS_E2_CAPS: Record<string, string> = {
  E1: '30',
  E2: '30',
  E3: '30',
  A1: '40',
  A2: '50',
  A3: '60',
  A4: '70',
  A5: '75',
};

/** E1 / 100$ package — total pool 30 EP. */
export const SHARE_BONUS_E1_CAPS: Record<string, string> = {
  E1: '30',
  E2: '30',
  E3: '30',
  A1: '30',
  A2: '30',
  A3: '30',
  A4: '30',
  A5: '30',
};

export const SHARE_BONUS_E3_TOTAL = '75';

/** Cap tables (admin-overridable via `reward.share_bonus.pools`). */
export interface ShareBonusPools {
  E1: Record<string, string>;
  E2: Record<string, string>;
  E3_total: string;
}

export const SHARE_BONUS_DEFAULT_POOLS: ShareBonusPools = {
  E1: SHARE_BONUS_E1_CAPS,
  E2: SHARE_BONUS_E2_CAPS,
  E3_total: SHARE_BONUS_E3_TOTAL,
};

export function shareBonusCapForLevel(
  levelCode: string,
  pkg: StarPackage,
  pools: ShareBonusPools = SHARE_BONUS_DEFAULT_POOLS,
): string {
  if (pkg === 'E1') {
    return pools.E1[levelCode] ?? pools.E1.A5 ?? '30';
  }
  if (levelCode.startsWith('S') || levelCode === 'A5') {
    return pools.E2.A5 ?? '75';
  }
  return pools.E2[levelCode] ?? pools.E2.E1 ?? '30';
}

export function shareBonusTotalPool(
  pkg: StarPackage,
  pools: ShareBonusPools = SHARE_BONUS_DEFAULT_POOLS,
): string {
  if (pkg === 'E1') return pools.E1.A5 ?? '30';
  if (pkg === 'E3') return pools.E3_total;
  return pools.E2.A5 ?? '75';
}

export const DYNAMIC_REWARD_CONFIG_KEYS = {
  BALANCE_AWARD_PCT: 'dynamic.balance_award_pct',
  SHARE_BONUS_POOLS: 'reward.share_bonus.pools',
} as const;
